import { useRef, useEffect } from 'react';

/**
 * Keep track of the component mounted state.
 *
 * @returns {Object} The current state of mounted.
 */
export default () => {
  const isMounted = useRef(true);

  // Set the mounted state.
  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  return isMounted;
};
